import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoursewareService } from 'src/services/CoursewareService';
import { Error } from 'src/model/Error';
import { AlertService } from '../_alert';

@Component({
  selector: 'app-complete-registration',
  templateUrl: './complete-registration.component.html',
  styleUrls: ['./complete-registration.component.css']
})
export class CompleteRegistrationComponent implements OnInit {
  public Registered: boolean = false;
  public ErrorMessage: string = null;

  constructor(private route: ActivatedRoute, private coursewareService: CoursewareService) { }

  ngOnInit() {
    let memberID = this.route.snapshot.paramMap.get('memberID');
    if (!memberID)
      memberID = this.route.snapshot.queryParamMap.get('memberID');
    if (!memberID)
      return;
    if (memberID.endsWith("/"))
      memberID = memberID.replace("/","");

    if (memberID == null)
      return;
    this.coursewareService.CompleteRegistration(memberID).subscribe(data => {
      if (data == "Success")
      {
        this.Registered = true;
      } else{
        let error: Error = data;
        this.Registered = false;
        this.ErrorMessage = error.Message;
      }
    });
  }
}
